import { render, staticRenderFns } from "./activate1.vue?vue&type=template&id=648119f3&scoped=true"
import script from "./activate1.vue?vue&type=script&lang=js"
export * from "./activate1.vue?vue&type=script&lang=js"
import style0 from "../assets/list.scss?vue&type=style&index=0&id=648119f3&prod&lang=scss&scoped=true&external"
import style1 from "../assets/css/index.scss?vue&type=style&index=1&id=648119f3&prod&lang=scss&scoped=true&external"
import style2 from "../assets/windows.scss?vue&type=style&index=2&id=648119f3&prod&lang=scss&scoped=true&external"
import style3 from "./activate1.vue?vue&type=style&index=3&id=648119f3&prod&lang=scss&scoped=true"
import style4 from "./activate1.vue?vue&type=style&index=4&id=648119f3&prod&lang=css"
import style5 from "../assets/css/mobile.scss?vue&type=style&index=5&id=648119f3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648119f3",
  null
  
)

export default component.exports